import { ClockPickerView } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { FormDateTimePicker } from "../../../../../components/fields";
import useDebounceCallback from "../../../../../hooks/useDebouncedCallback";
import { RentalLocationType } from "../../../../../types";
import { shouldDisableRentalDate, shouldDisableRentalTime } from "../../../../../utils";
import { rangeDateValidity, stepState, totalRentalDaysState } from "../../../recoil";
import { IFormValues, InsertBookingStep } from "../../../types";
import { IRangeDate } from "../../../../../api/services";

const DropoffDate = () => {

    const { t } = useTranslation('booking');

    const step = useRecoilValue(stepState);
    const totalRentalDays = useRecoilValue(totalRentalDaysState);
    const rangeDate = useRecoilValue<IRangeDate | undefined>(rangeDateValidity);

    const { getValues, trigger } = useFormContext<IFormValues>();

    const pickupDate = useWatch<IFormValues, "basicDetails.pickupDate">({
        name: 'basicDetails.pickupDate'
    });

    const shouldDisableDate = useCallback((date: dayjs.Dayjs) => {
        return shouldDisableRentalDate(date, getValues('basicDetails.dropoffLocation'), RentalLocationType.Dropoff, [], rangeDate);
    }, [rangeDate]);
    const shouldDisableTime = useCallback((time: number, clockTime: ClockPickerView) => {
        return shouldDisableRentalTime(time, clockTime, RentalLocationType.Dropoff, getValues('basicDetails.dropoffLocation'), getValues('basicDetails.dropoffDate'));
    }, []);
    const handleChange = useDebounceCallback(() => {
        trigger('basicDetails.dropoffDate');
    }, 300, []);

    return (
        <FormDateTimePicker<IFormValues>
            name="basicDetails.dropoffDate"
            label={t('label.dropoffDate')}
            onChange={handleChange}
            minDateTime={pickupDate || undefined}
            maxDateTime={pickupDate?.add(30, 'day')}
            shouldDisableDate={shouldDisableDate}
            shouldDisableTime={shouldDisableTime}
            disabled={step === InsertBookingStep.CUSTOMER_DETAILS}
            textFieldProps={{
                helperText: `Total Rental Days: ${totalRentalDays}`,
            }}
        />
    );
};

export default DropoffDate;
